import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
/**
 * Utility function to merge class names using clsx and tailwind-merge
 */ export function cn() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return twMerge(clsx(inputs));
}
/**
 * Centralized breakpoint configuration
 * All breakpoint values should be imported from this file to ensure consistency
 */ export var BREAKPOINTS = {
    sm: 640,
    md: 768,
    lg: 1280,
    xl: 1536
};
// Helper functions for using breakpoints in JavaScript
export var isSmallScreen = function(width) {
    return width < BREAKPOINTS.sm;
};
export var isMediumScreen = function(width) {
    return width >= BREAKPOINTS.sm && width < BREAKPOINTS.lg;
};
export var isLargeScreen = function(width) {
    return width >= BREAKPOINTS.lg;
};
// Media query strings for use in @emotion/styled
export var MEDIA_QUERIES = {
    sm: "@media (min-width: ".concat(BREAKPOINTS.sm, "px)"),
    md: "@media (min-width: ".concat(BREAKPOINTS.md, "px)"),
    lg: "@media (min-width: ".concat(BREAKPOINTS.lg, "px)"),
    xl: "@media (min-width: ".concat(BREAKPOINTS.xl, "px)"),
    smMax: "@media (max-width: ".concat(BREAKPOINTS.sm - 1, "px)"),
    mdMax: "@media (max-width: ".concat(BREAKPOINTS.md - 1, "px)"),
    lgMax: "@media (max-width: ".concat(BREAKPOINTS.lg - 1, "px)"),
    xlMax: "@media (max-width: ".concat(BREAKPOINTS.xl - 1, "px)"),
    smToLg: "@media (min-width: ".concat(BREAKPOINTS.sm, "px) and (max-width: ").concat(BREAKPOINTS.lg - 1, "px)")
};
/**
 * VSCode 환경인지 확인하는 유틸리티 함수
 * @returns VSCode WebView 환경이면 true, 아니면 false
 */ export var isVSCodeEnvironment = function() {
    // VSCode WebView API 존재 여부로 판단
    return typeof window !== 'undefined' && typeof window.acquireVsCodeApi !== 'undefined';
};
